import { LoggerService } from './logger.service';
import { TranslateService } from '@ngx-translate/core';
import { ToastService } from './toast.service';
import { Injectable } from '@angular/core';
import { Network } from '@capacitor/network';
import { BehaviorSubject, Observable } from 'rxjs';
import { ToastController, Platform } from '@ionic/angular';
import { PluginListenerHandle } from '@capacitor/core';

export enum ConnectionStatus {
  Online,
  Offline
}


@Injectable({
  providedIn: 'root'
})


export class NetworkService {

  private status: any = new BehaviorSubject(ConnectionStatus.Offline);
  networkListener: PluginListenerHandle | any;

  constructor(
    private toastService: ToastService,
    public logger: LoggerService,
    public translate: TranslateService,
    private plt: Platform) {
    this.plt.ready().then(() => {
      this.initializeNetworkEvents();
    });
  }

  public initializeNetworkEvents() {

    this.networkListener = Network.addListener('networkStatusChange', res => {
      console.log('Network status changed', res);
      let status = res.connectionType !== 'none' ? ConnectionStatus.Online : ConnectionStatus.Offline;

      if (this.status.getValue() != status) {
        this.status.next(status);
        if (this.status.getValue() === ConnectionStatus.Offline) {
          this.logger.info('WE ARE OFFLINE');
          this.updateNetworkStatus(ConnectionStatus.Offline)
        } else if (this.status.getValue() === ConnectionStatus.Online) {
          this.logger.info('WE ARE ONLINE');
          this.updateNetworkStatus(ConnectionStatus.Online);
        }
      }
    });
  }

  private async updateNetworkStatus(status: ConnectionStatus) {
    this.status.next(status);
    let offline = this.translate.instant("network_error");
    let online = this.translate.instant("network_ok");
    let connection = (status == ConnectionStatus.Offline) ? offline : online;
    let color = (status == ConnectionStatus.Offline) ? "danger" : "success";
    let duration = (status == ConnectionStatus.Offline) ? 0 : 3000;
    const message = connection;
    const position = 'top';
    const button = this.translate.instant("ignore");
    // if (status == ConnectionStatus.Offline)
    //   this.toastService.showWithCloseButton(message, "offline-toast", position, color, null,button);
    // if (status == ConnectionStatus.Online) {
    //   if (this.toastService.offlineToast)
    //     this.toastService.offlineToast.dismiss();
    //   this.toastService.show(message, duration, position, color);
    // }
  }

  public onNetworkChange(): Observable<ConnectionStatus> {
    return this.status.asObservable();
  }

  public getCurrentNetworkStatus(): ConnectionStatus {
    return this.status.getValue();
  }
  async getNetWorkStatus() {
    let res = await Network.getStatus();
    let status = res.connectionType !== 'none' ? ConnectionStatus.Online : ConnectionStatus.Offline;
    this.status.next(status);
  }

  endNetworkListener() {
    if (this.networkListener) {
      this.networkListener.remove();
    }
  }
}